import { render, staticRenderFns } from "./SalesManagement.vue?vue&type=template&id=cfb78598&scoped=true&"
import script from "./SalesManagement.vue?vue&type=script&lang=js&"
export * from "./SalesManagement.vue?vue&type=script&lang=js&"
import style0 from "./SalesManagement.vue?vue&type=style&index=0&id=cfb78598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb78598",
  null
  
)

export default component.exports